// extracted by mini-css-extract-plugin
export var bodySections = "_56-8";
export var gray = "_56-7";
export var green = "_56-4";
export var iconContainer = "_56-9";
export var iconWidgetContainer = "_56-1";
export var phoneIcon = "_56-2";
export var red = "_56-5";
export var statusDot = "_56-3";
export var widgetContainer = "_56-0";
export var yellow = "_56-6";